/* Callejeros: cantidad con − y + en la ficha de producto y en las tarjetas de las colecciones,
   y precio de la talla elegida en las tarjetas. */
(function () {
  function crearCantidad(qw) {
    if (qw.__cjrQty) return;
    var qInput = qw.querySelector('[data-quantity-input]');
    if (!qInput) return;
    qw.__cjrQty = true;
    var qSelect = qw.querySelector('[data-quantity-select]');

    Array.prototype.forEach.call(qw.children, function (el) { el.style.display = 'none'; });
    var box = document.createElement('div');
    box.className = 'cjr-qty';
    box.innerHTML = '<button type="button" class="cjr-qty__btn" aria-label="Quitar uno">−</button>' +
      '<input type="text" class="cjr-qty__num" inputmode="numeric" pattern="[0-9]*" aria-label="Cantidad" value="1">' +
      '<button type="button" class="cjr-qty__btn" aria-label="Agregar uno">+</button>';
    qw.appendChild(box);

    var num = box.querySelector('.cjr-qty__num');
    var btns = box.querySelectorAll('.cjr-qty__btn');
    var valor = function () { var n = parseInt(num.value, 10); return isNaN(n) || n < 1 ? 1 : n; };
    var fijar = function (n) {
      n = Math.max(1, Math.min(99, n));
      num.value = n;
      qInput.value = n;
      if (qSelect && n <= 9) qSelect.value = String(n);
    };
    btns[0].addEventListener('click', function () { fijar(valor() - 1); });
    btns[1].addEventListener('click', function () { fijar(valor() + 1); });
    num.addEventListener('change', function () { fijar(valor()); });
    num.addEventListener('blur', function () { fijar(valor()); });
    fijar(1);
  }

  // Tarjetas: al elegir una talla, mostrar el precio de esa talla
  function precioTarjeta(card) {
    if (card.__cjrPrecio) return;
    card.__cjrPrecio = true;
    card.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches('.options-selection__option-value-input')) return;
      setTimeout(function () {
        var idInput = card.querySelector('form [name="id"]');
        var id = idInput && idInput.value;
        var items = card.querySelectorAll('.product-items-prices__item');
        if (!items.length) return;
        var match = id && card.querySelector('.product-items-prices__item[data-key="variant-' + id + '"]');
        Array.prototype.forEach.call(items, function (it) {
          var activo = match ? it === match : it.getAttribute('data-key') === '';
          it.classList.toggle('active', activo);
        });
      }, 60);
    });
  }

  function revisar(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('form[action*="/cart/add"] [data-quantity-wrapper]'),
      crearCantidad
    );
    Array.prototype.forEach.call(scope.querySelectorAll('productitem-form'), precioTarjeta);
  }

  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; revisar(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { revisar(document); });
  } else {
    revisar(document);
  }
  // Productos que se cargan después (filtros, "ver más", vista rápida)
  if ('MutationObserver' in window) {
    new MutationObserver(programar).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
